import { cloneDeep, debounce } from 'lodash-es'
import { loadApp } from './qiankun-core'
import { StateTypes, MicroAppTypes } from './interface'
import { removeWatermark, setWaterMark } from '@/utils/watermark'
const updateMicroCache = debounce((_this: any) => {
  window.postMessage(
    {
      type: 'updateKeepAlive',
      data: {}
    },
    window.origin
  )
  _this.dispatch('microApp/checkAppStatus')
}, 400)

const state: StateTypes = {
  microApps: [], // 应用列表
  loadApps: [], // 已加载应用
  maxNum: 20 // 最大应用数
}

const getter = {}

const mutations = {
  /**
   * 触发更新子应用keep-alive数组
   */
  updateMicroCacheList() {
    updateMicroCache(this)
  }
}

const actions = {
  /**
   * 获取应用json配置
   * @param context store上下文
   * @returns Promise
   */
  getMicroConfig(context: { state: StateTypes }) {
    // 全局加水印
    let user = (window as any).localStorage.getItem('userInfo')
    user = JSON.parse(user)
    if (user?.uid && user?.name) setWaterMark(user?.uid, user?.name)

    const state: StateTypes = context.state
    return new Promise<void>((resolve, reject) => {
      const requestURL = `${process.env.BASE_URL}config.json`
      const request = new XMLHttpRequest()
      request.open('GET', requestURL)
      request.responseType = 'text'
      request.send()
      request.onload = () => {
        state.microApps = JSON.parse(request.response).map(
          (item: { container: string; name: string }) => ({
            ...item,
            container: `${item.container}-${item.name}`
          })
        )
        resolve()
      }
    })
  },
  /**
   * 加载微应用
   * @param context
   * @param routePath tab中的route，路由地址
   */
  async setMicroApp(context: any, routePath: string) {
    const state: StateTypes = context.state
    const microApp: MicroAppTypes = state.microApps.find(item =>
      routePath.includes(item.activeRule)
    )
    if (!microApp) return
    // 特殊模块加水印
    // if (microApp.name === 'yt-portal-tis') {
    // let user = (window as any).localStorage.getItem('userInfo')
    // user = JSON.parse(user)
    // setWaterMark(user.uid, user.name)
    // }
    // 检查应用
    const isReady = await (this as any).dispatch('microApp/checkLoadApp', microApp)
    if (isReady) return
    // 加载应用
    loadApp(microApp).then(app => {
      // 进入已加载数组
      state.loadApps.push({
        ...cloneDeep(microApp),
        app
      })
      // 超过最大应用数卸载最先进入的应用
      if (state.loadApps.length > state.maxNum) {
        const removeItem = state.loadApps.shift()
        if (removeItem) {
          setTimeout(() => {
            removeItem.app && removeItem.app.unmount()
          }, 400)
        }
      }
    })
  },
  /**
   * 检查应用是否已加载
   * @param context
   * @param microApp 子应用配置
   * @returns Promise<boolean> true 已加载 false 未加载
   */
  checkLoadApp(context: any, microApp: MicroAppTypes) {
    return new Promise<boolean>((resolve, reject) => {
      // 是否在已加载应用数组里
      const isLoadIndex = state.loadApps.findIndex(item => item.name === microApp.name)
      if (isLoadIndex !== -1) {
        const appItem = state.loadApps[isLoadIndex]
        setTimeout(() => {
          // 检查是否已渲染
          const hasHtml = document.querySelector(appItem.container)?.innerHTML
          // 注销水印
          // if (appItem.name !== 'yt-portal-tis') {
          //   removeWatermark()
          // }
          if (hasHtml) return resolve(true)
          // 未渲染卸载app
          if (appItem) {
            console.log('即将卸载', appItem)
            appItem.app.unmount().then(() => {
              state.loadApps.splice(isLoadIndex, 1)
              return resolve(false)
            })
          }
        }, 400)
      } else {
        resolve(false)
      }
    })
  },
  /**
   * 检查tab中的应用状态，将未在tab中打开的应用销毁
   */
  checkAppStatus() {
    state.loadApps.forEach(item => {
      const isActive = (this as any).state.menu.tabList.some((tab: { routeUrl: string }) =>
        tab.routeUrl.includes(item.activeRule)
      )
      if (!isActive) {
        if (item.app.getStatus() === 'MOUNTED') {
          item.app.unmount()
          item.app = null
        }
      }
    })
    state.loadApps = state.loadApps.filter(item => item.app)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getter
}
